module.exports = __webpack_public_path__ + "img/status_blue.9831e706.svg";